export const determineExternalMode = (scenarioData, pathname) => {
  const isExternalRoute = pathname.includes("/externalscenario") || pathname.includes("/external_ondemandcoach");
  return isExternalRoute && scenarioData?.external_scenario === true;
};

export const determineRedirectPath = ({
  scenarioData,
  trainingProgram,
  isExternalMode,
  simulationId,
  simulationType,
  authToken,
}) => {
  if (isExternalMode) {
    return scenarioData.has_scoring_engine
      ? `/externalscenario_feedback/${simulationId}`
      : `/externalscenario/${scenarioData.id}`;
  }

  const isLesson =
    scenarioData.resources !== null && Array.isArray(scenarioData.resources);

  if (isLesson) {
    let targetScenarioId = null;
    if (trainingProgram?.steps) {
      for (const step of trainingProgram.steps) {
        const chapter = step.chapter;
        if (!chapter?.steps) continue;

        let currentFound = false;
        for (const scenarioStep of chapter.steps) {
          const scenario = scenarioStep.scenario;
          if (scenario.id === scenarioData.id) {
            currentFound = true;
            continue;
          }
          if (currentFound) {
            targetScenarioId = scenario.id;
            break;
          }
        }
        if (targetScenarioId) break;
      }
    }
    return targetScenarioId
      ? `/dashboard/simulate/${targetScenarioId}`
      : `/dashboard/trainingprogram/${trainingProgram.id}`;
  }

  if (authToken && simulationType !== "feedback_session") {
    return `/dashboard/feedback/${simulationId}`;
  }

  if (authToken && simulationType === "on_demand_coach") {
    return `/dashboard/on_demand_coach`;
  }

  if (authToken && simulationType === "feedback_session") {
    return null; // Do not redirect
  }

  return "/login"; // Fallback
};
